/** parseRSOFilters produce a filter object (see example) populated
 * from the given URLSearchParams object. */
export const parseRSOFilters = (params /* URLSearchParams */) => ({
  // Filters
  name_cnts: params.get("name_cnts"),
  object_cnts: params.get("object_cnts"),
  object_id: params.get("object_id"),
  object_ids: params.get("object_ids"),
  object_type: params.get("object_type"),
  cospar_cnts: params.get("cospar_cnts"),
  org_code: params.get("org_code"),
  source: params.get("source"),
  sort_order: params.get("sort_order") || "DESC",
  sort_by: params.get("sort_by") || "object_id",
})
